import { KEY_ALIAS_MAP } from '@/provider';

export const SHORTCUT_KEY_MAPPER = {
  alt: {
    MacOS: '⌥',
    Windows: 'Alt',
    Linux: 'Alt',
    iOS: '⌥',
    Android: 'Alt',
  },

  ctrl: {
    MacOS: '⌃',
    Windows: 'Ctrl',
    Linux: 'Ctrl',
    iOS: '⌃',
    Android: 'Ctrl',
  },

  cmd: {
    MacOS: '⌘',
    Windows: 'Win',
    Linux: 'Super',
    iOS: '⌘',
    Android: 'Super',
  },

  meta: {
    MacOS: '⌘',
    Windows: 'Win',
    Linux: 'Super',
    iOS: '⌘',
    Android: 'Super',
  },

  shift: {
    MacOS: '⇧',
    Windows: 'Shift',
    Linux: 'Shift',
    iOS: '⇧',
    Android: 'Shift',
  },

  [KEY_ALIAS_MAP.Backspace]: {
    MacOS: '⌫',
    Windows: 'Backspace',
    Linux: 'Backspace',
    iOS: '⌫',
    Android: 'Backspace',
  },

  [KEY_ALIAS_MAP.Delete]: {
    MacOS: '⌦',
    Windows: 'Delete',
    Linux: 'Delete',
    iOS: '⌦',
    Android: 'Delete',
  },

  [KEY_ALIAS_MAP.Enter]: {
    MacOS: '↩',
    Windows: 'Enter',
    Linux: 'Enter',
    iOS: '↩',
    Android: 'Enter',
  },

  [KEY_ALIAS_MAP.Space]: {
    MacOS: '␣',
    Windows: 'Space',
    Linux: 'Space',
    iOS: '␣',
    Android: 'Space',
  },

  [KEY_ALIAS_MAP.Tab]: {
    MacOS: '⇥',
    Windows: 'Tab',
    Linux: 'Tab',
    iOS: '⇥',
    Android: 'Tab',
  },

  [KEY_ALIAS_MAP.ArrowLeft]: {
    MacOS: '←',
    Windows: '←',
    Linux: '←',
    iOS: '←',
    Android: '←',
  },

  [KEY_ALIAS_MAP.ArrowRight]: {
    MacOS: '→',
    Windows: '→',
    Linux: '→',
    iOS: '→',
    Android: '→',
  },

  [KEY_ALIAS_MAP.ArrowUp]: {
    MacOS: '↑',
    Windows: '↑',
    Linux: '↑',
    iOS: '↑',
    Android: '↑',
  },

  [KEY_ALIAS_MAP.ArrowDown]: {
    MacOS: '↓',
    Windows: '↓',
    Linux: '↓',
    iOS: '↓',
    Android: '↓',
  },

  [KEY_ALIAS_MAP.Escape]: {
    MacOS: 'Esc',
    Windows: 'Esc',
    Linux: 'Esc',
    iOS: 'Esc',
    Android: 'Esc',
  },
} as const;
